import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  InputGroup,
  InputNumber,
  RangeSlider,
  CheckPicker,
  CheckTreePicker,
  Button,
  Icon,
  MultiCascader,
  IconButton,
} from 'rsuite'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../../utils/loading'
import ErrorWidget from '../../errorWidget/ErrorWidget'
import './styles.css'

import OverallNodeChart from '../../dashboard/charts/OverallNodeChart'
import OverallNodeProvinceChart from '../../dashboard/charts/OverallNodeProvinceChart'
import BasicAreaChart from '../../dashboard/charts/echartWidgets/BasicAreaChart'
import { Controller, useForm } from 'react-hook-form'
import {
  getOverAllNodeProjectsSchema,
  searchOverAllNodeProjectsSchema,
} from '../../../redux/actions/dashboardDep6'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import PrintButton from '../../../components/buttons/printButton/printButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import pathname from '../../../constants/pathname'

export default function OverAllNodeProjects() {
  const history = useHistory()
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [header, setHeader] = useState()

  const [valueMinMax, setValueMinMax] = useState([1, 1000000])
  const [chartMapOption, setChartMapOption] = useState()
  const [mapData, setMapData] = useState(null)
  const [loading, setLoading] = useState(true)

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [isLoadingTable, setIsLoadingTable] = useState(false)

  const [summaryId, setSummaryId] = useState()
  const [dashGoald10YearId, setDashGoald10YearId] = useState()
  const [budgetNodeId, setBudgetNodeId] = useState()
  const [perprovinceId, setPerprovinceId] = useState()
  const [projectCode, setProjectCode] = useState()
  const [budgetYear, setBudgetYear] = useState()
  const [nodeId, setNodeId] = useState()
  const [budgetStart, setBudgetStart] = useState()
  const [budgetEnd, setBudgetEnd] = useState()
  const [issueId, setIssueId] = useState()
  const [location, setLocation] = useState()
  const [criOrderBy, setCriOrderBy] = useState()

  // const rangeSliderValue = { begin: 0, to: 100000000 }

  const [viewState, setViewState] = useState({
    longitude: 100.0,
    latitude: 20.0,
    zoom: 8,
  })

  const layerStyle = {
    id: 'districts',
    type: 'fill',
    paint: {
      'fill-color': [
        'interpolate',
        ['linear'],
        ['get', 'population'],
        0,
        '#f1f5f9',
        50000,
        '#60a5fa',
        100000,
        '#1e40af',
      ],
      'fill-opacity': 0.8,
      'fill-outline-color': '#ffffff',
    },
  }

  const { Column, HeaderCell, Cell, Pagination } = Table

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  useEffect(() => {
    // console.log('load ref ID => ', referenceID)

    handleGetResponse()
  }, [])

  const mockSchema = {
    header: 'รายงานภาพรวมโครงการย่อย สำนัก 6',
    forms: {
      summary: [
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: { id: 'x01', title: 'จำนวนแกนนำโครงการ (คน)', value: '35,456' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: {
            id: 'x02',
            title: 'จำนวนกลุ่มเป้าหมายที่ได้รับประโยชน์ (ครัวเรือน)',
            value: '84,871',
          },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: { id: 'x03', title: 'จำนวนกลุ่มเป้าหมายที่ได้รับประโยชน์ (คน)', value: '289,421' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: { id: 'x04', title: 'ข้อมูลการปรับเปลี่ยนพฤติกรรม (ครัวเรือน)', value: '45,332' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: { id: 'x05', title: 'ข้อมูลการปรับเปลี่ยนพฤติกรรม (คน)', value: '151,464' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 4 },
          data: { id: 'x06', title: 'ข้อมูลสภาพแวดล้อม (สังคม)', value: '3,923' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 8 },
          data: { id: 'x07', title: 'ข้อมูลสภาพแวดล้อม (กายภาพ)', value: '5,158' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 8 },
          data: { id: 'x08', title: 'จำนวนนวัตกรรม/พื้นที่ต้นแบบ (แห่ง/ชิ้น)', value: '733' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 8 },
          data: { id: 'x09', title: 'จำนวนคนต้นแบบ', value: '5,174' },
        },
      ],
      dashboardInfo: {
        totalProject: {
          setCol: { xxs: 24, xsm: 24, xmd: 12, xlg: 12 },
          title: 'จำนวนโครงการทั้งหมด',
          value: '1,231',
        },
        totalBudget: {
          setCol: { xxs: 24, xsm: 24, xmd: 12, xlg: 12 },
          title: 'งบประมาณทั้งหมด (บาท)',
          value: '72,155,175',
        },
        dashGoald10Year: {
          title: 'โครงการตามประเด็นเป้า 10 ปี สสส.',
          setting: {
            compStyle: { height: '280px', width: '100%' },
            xAxisData: [
              'สุขภาพจิต',
              'กิจกรรมทางกาย',
              'ยาสูบ',
              'อาหาร',
              'แอลกอฮอล์',
              'สารเสพติด',
              'อุบัติเหตุ',
              'สุขภาวะทางเพศ',
              'สิ่งแวดล้อม',
              'การป้องกันโรค เช่น การให้วัคซีน',
              'สุขภาวะครอบครัว',
              'การคุ้มครองผู้บริโภค',
              'ความไม่เท่าเทียมด้านสุขภาพ',
              'การพนัน',
              'ภัยพิบัติ',
              'สุขภาวะชุมชน',
              'ระบบสุขภาพ',
              'สุขภาวะองค์กร',
              'สุขภาวะทางปัญญา',
              'การศึกษา',
              'สื่อสุขภาวะ',
              'การสนับสนุนสถานการณ์โควิด-19',
              'การทำงานเรื่องสุขภาพในช่องปาก',
              'อื่น ๆ',
            ],
            seriesData: [
              { value: 300, id: '4821' },
              { value: 200, id: '9154' },
              { value: 100, id: '1376' },
              { value: 53, id: '8460' },
              { value: 78, id: '6249' },
              { value: 90, id: '7032' },
              { value: 43, id: '1548' },
              { value: 67, id: '2385' },
              { value: 170, id: '9017' },
              { value: 46, id: '4463' },
              { value: 69, id: '7821' },
              { value: 77, id: '6194' },
              { value: 120, id: '5028' },
              { value: 98, id: '3937' },
              { value: 77, id: '2856' },
              { value: 106, id: '8701' },
              { value: 250, id: '1295' },
              { value: 100, id: '6702' },
              { value: 68, id: '4380' },
              { value: 67, id: '9634' },
              { value: 87, id: '7549' },
              { value: 90, id: '5812' },
              { value: 120, id: '2971' },
              { value: 50, id: '8490' },
            ],
          },
        },
        dashProjectDetailBudgetNode: {
          title: 'รายละเอียด จำนวนโครงการและงบประมาณ แยกตาม Node',
          setting: {
            compStyle: { height: '280px', width: '100%' },
            nodeData: [
              { value: 550, id: '8490' },
              { value: 400, id: '8490' },
              { value: 300, id: '8490' },
              { value: 350, id: '8490' },
            ],
            nodeGroup: ['Node จังหวัด', 'Node เด็ก', 'Node เปราะบาง', 'Node ฐานราก'],
            budgetData: [3000000, 4000000, 5000000, 2000000],
          },
        },
        projectPerProvinceQty: {
          title: 'จำนวนโครงการรายจังหวัด',
          setting: {
            seriesData: [
              { name: 'กรุงเทพมหานคร', value: 5588000 },
              { name: 'พระนครศรีอยุธยา', value: 1 },
              { name: 'กระบี่', value: 467000 },
              { name: 'กาญจนบุรี', value: 887000 },
              { name: 'กาฬสินธุ์', value: 998000 },
              { name: 'กำแพงเพชร', value: 745000 },
              { name: 'ขอนแก่น', value: 1796000 },
              { name: 'จันทบุรี', value: 527000 },
              { name: 'ฉะเชิงเทรา', value: 709000 },
              { name: 'สุโขทัย', value: 611000 },
              { name: 'สุพรรณบุรี', value: 863000 },
              { name: 'สุราษฎร์ธานี', value: 1040000 },
              { name: 'สุรินทร์', value: 1393000 },
              { name: 'หนองคาย', value: 520000 },
              { name: 'หนองบัวลำภู', value: 508000 },
              { name: 'อ่างทอง', value: 284000 },
              { name: 'อำนาจเจริญ', value: 383000 },
              { name: 'อุดรธานี', value: 1568000 },
              { name: 'อุตรดิตถ์', value: 460000 },
              { name: 'อุทัยธานี', value: 335000 },
              { name: 'อุบลราชธานี', value: 1882000 },
            ],
          },
        },
        projectDetail: {
          title: 'รายละเอียดโครงการ',
          values: [
            {
              projectCode: '65-xxxxx1',
              projectName: 'อาหารปลอดภัยใส่ใจสุขภาพบ้านยายม่อม',
              issue: 'อาหารปลอดภัย',
              province: 'ตลาด',
              budget: '80,000',
            },
            {
              projectCode: '65-xxxxx2',
              projectName: 'อาสาสมัครพิทักษ์สีเขียว',
              issue: 'มลพิษสิ่งแวดล้อม',
              province: 'เลย',
              budget: '380,000',
            },
            {
              projectCode: '65-xxxxx3',
              projectName: 'หาดสวยด้วยมือเรา',
              issue: 'มลพิษสิ่งแวดล้อม',
              province: 'กระบี่',
              budget: '1380,000',
            },
          ],
        },
      },
      searchForms: {
        budgetYear: {
          name: 'budgetYear',
          label: 'ปีงบประมาณ',
          value: '',
          options: [
            { disabled: false, label: 'เด็ก', value: '1' },
            { disabled: false, label: 'เปราะบาง', value: '2' },
            { disabled: false, label: 'คนรุ่นใหม่', value: '3' },
          ],
        },
        node: {
          name: 'node',
          label: 'Node',
          value: '',
          options: [
            { disabled: false, label: 'เด็ก', value: '1' },
            { disabled: false, label: 'เปราะบาง', value: '2' },
            { disabled: false, label: 'คนรุ่นใหม่', value: '3' },
          ],
        },
        budget: {
          label: 'งบประมาณ',
          start: {
            name: 'budgetStart',
            value: '',
            min: 0,
            max: 99,
          },
          end: {
            name: 'budgetEnd',
            value: '',
            min: 0,
            max: 99,
          },
        },
        issue: {
          name: 'issue',
          label: 'ประเด็น',
          options: [
            { disabled: false, label: 'เด็กเยาวชน / เพศ', value: '1' },
            { disabled: false, label: 'เท่าทันสื่อ', value: '2' },
            { disabled: false, label: 'เศรษฐกิจ รายได้', value: '3' },
          ],
        },
        location: {
          name: 'location',
          label: 'ภาค, จังหวัด, อำเภอ',
          options: [
            {
              label: 'Electronics',
              value: 'electronics',
              disabled: true, // ❌ ปิดการเลือก Level 1
              children: [
                {
                  label: 'Mobile',
                  value: 'mobile',
                  disabled: true, // ❌ ปิดการเลือก Level 2
                  children: [
                    { label: 'iPhone', value: 'iphone' }, // ✅ เลือกได้
                    { label: 'Samsung', value: 'samsung' }, // ✅ เลือกได้
                    { label: 'Xiaomi', value: 'xiaomi' }, // ✅ เลือกได้
                  ],
                },
                {
                  label: 'Laptop',
                  value: 'laptop',
                  disabled: true,
                  children: [
                    { label: 'MacBook', value: 'macbook' },
                    { label: 'Dell', value: 'dell' },
                    { label: 'Lenovo', value: 'lenovo' },
                  ],
                },
              ],
            },
            {
              label: 'Clothing',
              value: 'clothing',
              disabled: true,
              children: [
                {
                  label: 'Men',
                  value: 'men',
                  disabled: true,
                  children: [
                    { label: 'Shirt', value: 'shirt' },
                    { label: 'Jeans', value: 'jeans' },
                  ],
                },
                {
                  label: 'Women',
                  value: 'women',
                  disabled: true,
                  children: [
                    { label: 'Dress', value: 'dress' },
                    { label: 'Skirt', value: 'skirt' },
                  ],
                },
              ],
            },
          ],
        },
        button: {
          search: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'ค้นหา',
          },
          cancel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 24 },
            label: 'ยกเลิก',
          },
          exportExcel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'Download Excel',
          },
        },
      },
    },
  }

  const handleGetResponse = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await getOverAllNodeProjectsSchema()
      // console.log('res => ', res.form)

      setSchema(res?.form)
      setHeader(res?.header || '')
      setValueMinMax([
        res?.form?.searchForms?.budget?.start?.min || 1,
        res?.form?.searchForms?.budget?.end?.max || 99999,
      ])
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSortColumn = (sortColumn, sortType) => {
    console.log('handleSortColumn => ', sortColumn, sortType)
    setIsLoadingTable(true)
    // setCriOrderBy(`${sortColumn}_${sortType}`)

    handleClickSearch('criOrderBy', `${sortColumn}_${sortType}`)

    setTimeout(() => {
      setSortColumn(sortColumn)
      setSortType(sortType)
      setIsLoadingTable(false)
    }, 500)
  }

  const handleCancel = () => {
    // setValue('location', [])
    console.log('handleCancel')

    setSummaryId()
    setDashGoald10YearId()
    setBudgetNodeId()
    setPerprovinceId()
    setProjectCode()
    setBudgetYear()
    setNodeId()

    setValueMinMax([
      schema?.searchForms?.budget?.start?.min || 1,
      schema?.searchForms?.budget?.end?.max || 99999,
    ])
    setBudgetStart()
    setBudgetEnd()
    setIssueId()
    setLocation()
    setCriOrderBy()

    handleGetResponse()
  }

  const handleExportExcel = () => {
    alert('handleExportExcel')
  }

  const handleSearch = async () => {
    let regionIdArr = []
    let provinceIdArr = []
    let districtIdArr = []
    if (location?.length > 0) {
      location.map((item) => {
        let itemSplit = item?.split('||')
        if (itemSplit.length > 0) {
          if (itemSplit[1] == 'DISTRICT') {
            districtIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'REGION') {
            regionIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'PROVINCE') {
            provinceIdArr.push(itemSplit[0])
          }
        }
      })
    }

    const req = {
      summaryId: summaryId || '',
      goald10yearId: dashGoald10YearId || '',
      budgetnodeId: budgetNodeId || '',
      perprovinceId: perprovinceId || '',
      projectCode: projectCode || '',
      budgetYear: budgetYear || 0,
      nodeId: nodeId || '',
      budgetStart: budgetStart || 0,
      budgetEnd: budgetEnd || 0,
      issueId: issueId?.length > 0 ? issueId.toString() : '',
      regionId: regionIdArr?.length > 0 ? regionIdArr.toString() : '',
      provinceId: provinceIdArr?.length > 0 ? provinceIdArr.toString() : '',
      districtId: districtIdArr?.length > 0 ? districtIdArr.toString() : '',
      criOrderBy: criOrderBy || '',
    }

    await callApiSearch(req)
  }

  const handleClickSearch = async (ctype = null, cid = null) => {
    let regionIdArr = []
    let provinceIdArr = []
    let districtIdArr = []
    if (location?.length > 0) {
      location.map((item) => {
        let itemSplit = item?.split('||')
        if (itemSplit.length > 0) {
          if (itemSplit[1] == 'DISTRICT') {
            districtIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'REGION') {
            regionIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'PROVINCE') {
            provinceIdArr.push(itemSplit[0])
          }
        }
      })
    }

    const req = {
      summaryId: ctype == 'summary' ? cid || '' : summaryId || '',
      goald10yearId: ctype == 'dashGoald10Year' ? cid || '' : dashGoald10YearId || '',
      budgetnodeId: ctype == 'budgetNode' ? cid || '' : budgetNodeId || '',
      perprovinceId: ctype == 'perprovince' ? cid || '' : perprovinceId || '',
      projectCode: ctype == 'projectCode' ? cid || '' : projectCode || '',
      budgetYear: budgetYear || 0,
      nodeId: nodeId || '',
      budgetStart: budgetStart || 0,
      budgetEnd: budgetEnd || 0,
      issueId: issueId?.length > 0 ? issueId.toString() : '',
      regionId: regionIdArr?.length > 0 ? regionIdArr.toString() : '',
      provinceId: provinceIdArr?.length > 0 ? provinceIdArr.toString() : '',
      districtId: districtIdArr?.length > 0 ? districtIdArr.toString() : '',
      criOrderBy: ctype == 'criOrderBy' ? cid || '' : criOrderBy || '',
    }

    switch (ctype) {
      case 'summary':
        setSummaryId(cid)
        break

      case 'dashGoald10Year':
        setDashGoald10YearId(cid)
        break

      case 'budgetNode':
        setBudgetNodeId(cid)
        break

      case 'perprovince':
        setPerprovinceId(cid)
        break

      case 'projectCode':
        setProjectCode(cid)
        break

      case 'criOrderBy':
        setCriOrderBy(cid)
        break

      default:
        break
    }

    await callApiSearch(req)
  }

  const callApiSearch = async (req) => {
    setIsLoading(true)
    startLoading()

    try {
      var response = await searchOverAllNodeProjectsSchema(req)

      setSchema(response.form)
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorWidget statusCode={error?.statusCode} errorMessage={error?.errorMessage} />
        </Col>
      </Row>
    )
  }

  if (!schema || isLoading) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <OverlayLoader />
          <PanalLoadingTemplate />
        </Col>
      </Row>
    )
  }

  const CardAmt = (props) => {
    return (
      <Panel
        {...props}
        bordered
        className="card-amt-panel"
        onClick={() => {
          handleClickSearch('summary', props?.data?.id)
        }}
        // header={<div className="card-amt-row-header">{props.data.title}</div>}
      >
        <Row>
          <Col md={24} sm={24} xs={24} className="card-amt-row-header">
            {props.data.title}
          </Col>
        </Row>

        <Row className="card-amt-row-value">
          <Col md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
            {props.data.value}
          </Col>
        </Row>
      </Panel>
    )
  }

  return (
    <>
      <div style={{ marginTop: 50, fontSize: 16 }}>
        {header && (
          <Panel bordered bodyFill style={{ marginTop: 5 }}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} className="dashboard-header">
                <p className="dashboard-header-txt">{header || ''}</p>
              </Col>
            </Row>
          </Panel>
        )}

        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
              {schema?.summary?.length > 0 && (
                <Row>
                  {schema?.summary?.map((item, index) => {
                    return (
                      <Col
                        xs={item.setCol.xxs}
                        sm={item.setCol.xsm}
                        md={item.setCol.xmd}
                        lg={item.setCol.xlg}
                      >
                        <CardAmt data={item?.data} />
                      </Col>
                    )
                  })}
                </Row>
              )}
            </Panel>
          </Col>
        </Row>

        {schema?.dashboardInfo && (
          <Row>
            <Col xs={24} sm={24} md={18} lg={18}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Row>
                      {schema?.dashboardInfo?.totalProject && (
                        <Col
                          xs={schema?.dashboardInfo?.totalProject?.setCol.xxs}
                          sm={schema?.dashboardInfo?.totalProject?.setCol.xsm}
                          md={schema?.dashboardInfo?.totalProject?.setCol.xmd}
                          lg={schema?.dashboardInfo?.totalProject?.setCol.xlg}
                        >
                          <Panel bordered bodyFill style={{ marginBottom: 5 }}>
                            <div className="title-view">
                              {schema?.dashboardInfo?.totalProject?.title || ''}
                            </div>
                            <div className="title-value">
                              {schema?.dashboardInfo?.totalProject?.value || '0'}
                            </div>
                          </Panel>
                        </Col>
                      )}

                      {schema?.dashboardInfo?.totalBudget && (
                        <Col
                          xs={schema?.dashboardInfo?.totalBudget?.setCol.xxs}
                          sm={schema?.dashboardInfo?.totalBudget?.setCol.xsm}
                          md={schema?.dashboardInfo?.totalBudget?.setCol.xmd}
                          lg={schema?.dashboardInfo?.totalBudget?.setCol.xlg}
                        >
                          <Panel bordered bodyFill style={{ marginBottom: 5 }}>
                            <div className="title-view">
                              {schema?.dashboardInfo?.totalBudget?.title || ''}
                            </div>
                            <div className="title-value">
                              {schema?.dashboardInfo?.totalBudget?.value || '0'}
                            </div>
                          </Panel>
                        </Col>
                      )}
                    </Row>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Row>
                      {schema?.dashboardInfo?.dashGoald10Year && (
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <Panel bordered bodyFill>
                            <div className="title-view">
                              {schema?.dashboardInfo?.dashGoald10Year?.title || ''}
                            </div>
                            <BasicAreaChart
                              compStyle={
                                schema?.dashboardInfo?.dashGoald10Year?.setting.compStyle || null
                              }
                              xAxisData={
                                schema?.dashboardInfo?.dashGoald10Year?.setting.xAxisData || []
                              }
                              seriesData={
                                schema?.dashboardInfo?.dashGoald10Year?.setting.seriesData || []
                              }
                              onClickCheart={(param) => {
                                // setDashGoald10YearId(param.id)
                                handleClickSearch('dashGoald10Year', param.id)
                              }}
                            />
                          </Panel>
                        </Col>
                      )}

                      {schema?.dashboardInfo?.dashProjectDetailBudgetNode && (
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <Panel bordered bodyFill style={{ marginTop: 5 }}>
                            <div className="title-view">
                              {schema?.dashboardInfo?.dashProjectDetailBudgetNode.title || ''}
                            </div>
                            <OverallNodeChart
                              compStyle={
                                schema?.dashboardInfo?.dashProjectDetailBudgetNode?.setting
                                  ?.compStyle || null
                              }
                              nodeData={
                                schema?.dashboardInfo?.dashProjectDetailBudgetNode?.setting
                                  ?.nodeData || []
                              }
                              nodeGroup={
                                schema?.dashboardInfo?.dashProjectDetailBudgetNode?.setting
                                  ?.nodeGroup || []
                              }
                              budgetData={
                                schema?.dashboardInfo?.dashProjectDetailBudgetNode?.setting
                                  ?.budgetData || []
                              }
                              onClickCheart={(param) => {
                                if (!param?.id) {
                                  return false
                                }
                                // console.log('param => ', param)
                                // setBudgetNodeId(param.id)
                                handleClickSearch('budgetNode', param.id)
                              }}
                            />
                          </Panel>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Panel>

              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  {schema?.dashboardInfo?.projectPerProvinceQty && (
                    <Col xs={24} sm={24} md={6} lg={6}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.projectPerProvinceQty?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <OverallNodeProvinceChart
                            seriesData={
                              schema?.dashboardInfo?.projectPerProvinceQty?.setting.seriesData || []
                            }
                            onClickCheart={(param) => {
                              if (!param?.id) {
                                return false
                              }
                              // console.log('param => ', param)
                              // setPerprovinceId(param.id)
                              handleClickSearch('perprovince', param.id)
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.projectDetail && (
                    <Col xs={24} sm={24} md={18} lg={18}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.projectDetail?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <Table
                            height={420}
                            data={schema?.dashboardInfo?.projectDetail?.values || []}
                            wordWrap
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                            loading={isLoadingTable}
                            onRowClick={(data) => {
                              // console.log(data)
                              // setProjectCode(data.projectCode)
                              handleClickSearch('projectCode', data.projectCode)
                            }}
                            className="table-data"
                          >
                            <Column width={150} align="center" fixed sortable>
                              <HeaderCell>รหัสโครงการ</HeaderCell>
                              <Cell dataKey="projectCode" />
                            </Column>

                            <Column width={250} sortable>
                              <HeaderCell>ชื่อโครงการ</HeaderCell>
                              <Cell dataKey="projectName" />
                            </Column>

                            <Column width={120} sortable>
                              <HeaderCell>ประเด็น</HeaderCell>
                              <Cell dataKey="issue" />
                            </Column>

                            <Column width={120} sortable>
                              <HeaderCell>จังหวัด</HeaderCell>
                              <Cell dataKey="province" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>งบประมาณ</HeaderCell>
                              <Cell dataKey="budget" />
                            </Column>

                            <Column width={130} align="center">
                              <HeaderCell>
                                <span></span>
                              </HeaderCell>

                              <Cell>
                                {(rowData) => {
                                  return (
                                    <IconButton
                                      appearance="ghost"
                                      color="orange"
                                      icon={
                                        <Icon icon={'pencil'} className="bt-gost-icon-radius-or" />
                                      }
                                      onClick={() => {
                                        sessionStorage.setItem(
                                          'projectId',
                                          rowData.subProjectVersionId
                                        )
                                        sessionStorage.setItem('param', '')

                                        history.push({
                                          pathname: `${pathname.subProject.overviewSubProject}`,
                                        })
                                      }}
                                    >
                                      {`แสดง`}
                                    </IconButton>
                                  )
                                }}
                              </Cell>
                            </Column>
                          </Table>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </Panel>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <div>
                <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                  {schema?.searchForms?.budgetYear && (
                    <Row className="filter-box">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-title">
                          {schema?.searchForms?.budgetYear?.label || ''}
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-box-input">
                          <Controller
                            name={schema?.searchForms?.budgetYear.name}
                            control={control}
                            render={(props) => {
                              return (
                                <SelectPicker
                                  data={schema?.searchForms?.budgetYear.options}
                                  // value={props.value}
                                  value={budgetYear || 0}
                                  placeholder="เลือก"
                                  block
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setBudgetYear(value)
                                  }}
                                />
                              )
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}

                  {schema?.searchForms?.node && (
                    <Row className="filter-box">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-title">{schema?.searchForms?.node?.label}</div>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-box-input">
                          <Controller
                            name={schema?.searchForms?.node.name}
                            control={control}
                            render={(props) => {
                              return (
                                <SelectPicker
                                  data={schema?.searchForms?.node.options}
                                  // value={props.value}
                                  value={nodeId || ''}
                                  placeholder="เลือก"
                                  block
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setNodeId(value)
                                  }}
                                />
                              )
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}

                  {schema?.searchForms?.budget && (
                    <Row className="filter-box">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-title">{schema?.searchForms?.budget?.label}</div>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-box-input">
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <InputGroup>
                                <InputNumber
                                  min={schema?.searchForms?.budget?.start?.min}
                                  max={schema?.searchForms?.budget?.start?.max}
                                  value={valueMinMax[0] || schema?.searchForms?.budget?.start?.min}
                                  onChange={(nextValue) => {
                                    const [start, end] = valueMinMax
                                    if (nextValue > end) {
                                      return
                                    }
                                    setValueMinMax([nextValue, end])
                                    setBudgetStart(nextValue)
                                  }}
                                />
                                <InputGroup.Addon>to</InputGroup.Addon>
                                <InputNumber
                                  min={schema?.searchForms?.budget?.end?.min}
                                  max={schema?.searchForms?.budget?.end?.max}
                                  value={valueMinMax[1] || schema?.searchForms?.budget?.end?.max}
                                  onChange={(nextValue) => {
                                    const [start, end] = valueMinMax
                                    if (start > nextValue) {
                                      return
                                    }
                                    setValueMinMax([start, nextValue])
                                    setBudgetEnd(nextValue)
                                  }}
                                />
                              </InputGroup>
                            </Col>
                            {/* <Col xs={24} sm={24} md={24} lg={24}>
                              <RangeSlider
                                progress
                                style={{ marginTop: 16 }}
                                value={value}
                                onChange={(value) => {
                                  setValue(value)
                                }}
                              />
                            </Col> */}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {schema?.searchForms?.issue && (
                    <Row className="filter-box">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-title">{schema?.searchForms?.issue?.label}</div>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-box-input">
                          <Controller
                            name={schema?.searchForms?.issue.name}
                            control={control}
                            render={(props) => {
                              return (
                                <CheckPicker
                                  data={schema?.searchForms?.issue.options}
                                  // value={props.value}
                                  value={issueId || []}
                                  placeholder="เลือก"
                                  block
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setIssueId(value)
                                  }}
                                />
                              )
                            }}
                          />
                          {/* <CheckPicker
                            data={[
                              {
                                disabled: false,
                                label: 'จังหวัด',
                                value: 1,
                              },
                            ]}
                            block
                          /> */}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {schema?.searchForms?.location && (
                    <Row className="filter-box">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="filter-title">{schema?.searchForms?.location?.label}</div>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Controller
                          name={schema?.searchForms?.location?.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckTreePicker
                                defaultExpandAll={false}
                                data={schema?.searchForms?.location.options}
                                name
                                block
                                placeholder="เลือก"
                                value={location || []}
                                // value={props.value}
                                renderTreeNode={(nodeData) => {
                                  return nodeData.label
                                }}
                                renderValue={(value, checkedItems) => {
                                  // let arrId =
                                  //   checkedItems?.map((item) => item.value)?.join(' , ') || null
                                  // setLocation(arrId)

                                  return (
                                    <span>
                                      {checkedItems.map((item) => item.label).join(' , ')}
                                    </span>
                                  )
                                }}
                                onChange={(value) => {
                                  // console.log('onChange => ', value)
                                  setLocation(value)
                                  // setValue(schema?.searchForms?.location?.name, value)
                                }}
                              />
                            )
                          }}
                        />

                        {/* <CheckTreePicker
                          data={schema?.searchForms?.location.options}
                          value={location}
                          onChange={(e) => {
                            onChangeLocation(e)
                            // console.log('e => ', e)
                            // setValue2(e)
                          }}
                          placeholder="Select items"
                          style={{ width: 300 }}
                          defaultExpandAll
                          cascade={false} // ❗ เพื่อเลือกเฉพาะ leaf
                        /> */}
                        <div className="filter-box-input"></div>
                      </Col>
                    </Row>
                  )}

                  {schema?.searchForms?.button && (
                    <Row className="filter-box">
                      {schema?.searchForms?.button?.search && (
                        <Col
                          xs={schema?.searchForms?.button?.search?.setCol.xxs}
                          sm={schema?.searchForms?.button?.search?.setCol.xsm}
                          md={schema?.searchForms?.button?.search?.setCol.xmd}
                          lg={schema?.searchForms?.button?.search?.setCol.xlg}
                        >
                          <SaveButton
                            icon={'search'}
                            block
                            children={schema?.searchForms?.button?.search?.label}
                            onClick={() => {
                              handleSearch()
                            }}
                          />
                        </Col>
                      )}

                      {schema?.searchForms?.button?.exportExcel && (
                        <Col
                          xs={schema?.searchForms?.button?.exportExcel?.setCol.xxs}
                          sm={schema?.searchForms?.button?.exportExcel?.setCol.xsm}
                          md={schema?.searchForms?.button?.exportExcel?.setCol.xmd}
                          lg={schema?.searchForms?.button?.exportExcel?.setCol.xlg}
                        >
                          <SaveButton
                            icon={'file-excel-o'}
                            block
                            children={schema?.searchForms?.button?.exportExcel?.label}
                            onClick={() => {
                              handleExportExcel()
                            }}
                          />
                        </Col>
                      )}

                      {schema?.searchForms?.button?.cancel && (
                        <Col
                          xs={schema?.searchForms?.button?.cancel?.setCol.xxs}
                          sm={schema?.searchForms?.button?.cancel?.setCol.xsm}
                          md={schema?.searchForms?.button?.cancel?.setCol.xmd}
                          lg={schema?.searchForms?.button?.cancel?.setCol.xlg}
                        >
                          <CancelButton
                            icon={'close-circle'}
                            block
                            children={schema?.searchForms?.button?.cancel?.label}
                            onClick={() => {
                              handleCancel()
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                  )}
                </Panel>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}
